// extracted by mini-css-extract-plugin
module.exports =  {"description":"ApBQmdHESQGXFBFKW4te","path":"O3Bca_BMS3r9UC80Mc34","single":"mfllenhhMOt5k5Gd07AA"};